import { useTranslation } from 'react-i18next';
import { PageHeader } from '../components/ui/PageHeader';
import { BinsBoard } from '../components/receiving/BinsBoard';
import { useCapabilitiesStore } from '../stores/capabilitiesStore';
import { useAuthStore } from '../stores/authStore';

/** The preparation zone and hand-over desk (spec §6, §9), for the counter and the warehouse. */
export default function BinsPage() {
  const { t } = useTranslation();
  const role =
    useCapabilitiesStore((s) => s.data?.role) ?? useAuthStore.getState().user?.role ?? '';
  return (
    <div>
      <PageHeader title={t('rcv.bins.pageTitle')} description={t('rcv.bins.pageSubtitle')} />
      <BinsBoard role={role} />
    </div>
  );
}
